import React from 'react';
import { Input } from 'antd';

interface NumericInputProps {
  value: string;
  placeholder?: string;
  disabled?: boolean;
  onChange: (value: string) => void; // Add onChange callback
}

export const NumericInput: React.FC<NumericInputProps> = ({
  value,
  placeholder,
  disabled,
  onChange,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const reg = /^-?\d*\.?\d*$/;
    if (inputValue === '' || reg.test(inputValue)) {
      onChange(inputValue);
    }
  };

  const handleBlur = () => {
    let valueTemp = value;
    if (
      valueTemp !== '' &&
      (isNaN(parseFloat(valueTemp)) || valueTemp.endsWith('.'))
    ) {
      valueTemp = '';
      onChange(valueTemp);
    }
  };

  return (
    <Input
      type={'number'}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder={placeholder}
      disabled={disabled}
    />
  );
};
